import { useState, useRef, useEffect } from "react";
import { Info } from "lucide-react";

// Interactive Smart Tip: an info icon that reveals explanatory text on hover or click.
export const SmartTip = ({ text, name }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  if (!text) return null;
  return (
    <span ref={ref} className="relative inline-flex align-middle"
      onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button type="button" data-testid={`smarttip-${name}`} aria-label="Smart Tip"
        onClick={(e) => { e.preventDefault(); setOpen((o) => !o); }}
        className="ml-1.5 text-[#9CA3AF] hover:text-[#D94833] transition-colors focus:outline-none">
        <Info size={14} />
      </button>
      {open && (
        <span data-testid={`smarttip-text-${name}`} role="tooltip"
          className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-40 w-64 sm:w-72 bg-[#041C3E] text-white text-xs leading-relaxed px-3 py-2.5 shadow-xl">
          {text}
          <span className="absolute left-1/2 -translate-x-1/2 top-full border-4 border-transparent border-t-[#041C3E]" />
        </span>
      )}
    </span>
  );
};
